module.exports = __webpack_public_path__ + "assets/img/eefc2b7fed146148ad585e8cc13b5e2c.svg";